import React, { useState } from 'react';

import PropTypes from 'prop-types';

import useNumGridCols from '../hooks/useNumGridCols';

// TODO: fix the actual row and col numbers
// check with mock in grid assets
const GridIndexInfo = ({ row, column, customVars }) => {
  // 1-based index
  const [showCustomVars, setShowCustomVars] = useState(false);
  const numGridColumns = useNumGridCols();

  // connect with manny, make this a FF or debug admin option
  const index = row * numGridColumns + column;
  return (
    <>
      <div className="flex justify-start gap-2">
        <p>Position: {index + 1}</p>
        <p>Row: {row + 1}</p>
        <p>Col: {column + 1}</p>
      </div>
      {customVars && (
        <div className="flex flex-col justify-start gap-1 mt-2">
          <button
            type="button"
            onClick={() => setShowCustomVars((show) => !show)}
          >
            {showCustomVars ? 'Hide Custom Vars' : 'Show Custom Vars'}
          </button>
          {showCustomVars &&
            Object.entries(customVars)?.map(([key, value]) => {
              return (
                <p key={key}>
                  {key}: {value || 'null'}
                </p>
              );
            })}
        </div>
      )}
    </>
  );
};

GridIndexInfo.propTypes = {
  column: PropTypes.number.isRequired,
  customVars: PropTypes.object,
  row: PropTypes.number.isRequired,
};

export default GridIndexInfo;
